<template>
  <f7-block>
    <f7-block-title>{{ $t('adminDashboard.documents') }}</f7-block-title>
    <div class="metric-grid">
      <div class="metric-card">
        <span class="metric-lbl">{{ $t('adminDashboard.totalDocuments') }}</span>
        <span class="metric-val">{{ fmt(data.totalDocuments) }}</span>
      </div>
      <div class="metric-card">
        <span class="metric-lbl">{{ $t('adminDashboard.documentsToday') }}</span>
        <span class="metric-val">{{ fmt(data.documentsUploadedToday) }}</span>
      </div>
      <div class="metric-card">
        <span class="metric-lbl">{{ $t('adminDashboard.totalStorageGB') }}</span>
        <span class="metric-val">{{ fmtDec(data.totalStorageUsedGB) }} GB</span>
      </div>
      <div class="metric-card">
        <span class="metric-lbl">{{ $t('adminDashboard.storageCost') }}</span>
        <span class="metric-val">{{ fmtCfa(data.storageCost) }}</span>
      </div>
    </div>
  </f7-block>
</template>
<script setup>
const props = defineProps({ data: { type: Object, required: true } });
function fmt(n) { return n != null ? Math.round(n).toLocaleString('fr-FR') : '-'; }
function fmtDec(v, d=2) { if (v == null) return '-'; return parseFloat(v).toFixed(d); }
function fmtCfa(v) { if (v == null) return '-'; const n = parseFloat(v) || 0; return n.toLocaleString('fr-FR', {maximumFractionDigits:0}) + ' FCFA'; }
</script>
<style scoped>
.metric-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(150px, 1fr)); gap: 10px; }
.metric-card { display:flex; flex-direction:column; align-items:center; gap:4px; padding:14px 8px; border-radius:12px; background:var(--f7-list-bg-color,#f5f5f5); }
.metric-lbl { font-size:11px; color:var(--f7-on-surface-variant,#8e8e93); text-align:center; line-height:1.3; }
.metric-val { font-size:18px; font-weight:700; color:var(--f7-text-color,#333); }
</style>